export enum SceneAvailability {
  Included = 'included',
  Selectable = 'selectable',
  Upgrade = 'upgrade',
  StudioOnly = 'studio-only'
}

export enum SceneDisplayGroup {
  Studio = 'studio-scenes',
  Outdoor = 'outdoor-scenes',
  Destination = 'destination-scenes'
}

export interface SceneGroupItem {
  sceneId: string
  availability: SceneAvailability
}

export interface SceneGroup {
  id: SceneDisplayGroup
  title: string
  /**
   * Optional subhead rendered below the group title (desktop only — hidden
   * on mobile per the Figma RS+ school-scenes spec). Used today by the RS+
   * "Your Pre-Selected School Scenes" header to explain the fixed-scene
   * constraint; standard-flow groups leave it unset.
   */
  description?: string
  /** When set, group is in "pick more" mode with selection circles */
  maxSelections?: number
  /** Right-side action text for upgrade groups (e.g., "Upgrade" or "Upgrade Details") */
  upgradeActionLabel?: string
  items: SceneGroupItem[]
}
